import React from "react";
import { useTranslation } from "react-i18next";
import { SENDOUT_NAMESPACE } from "src/i18n";
import "src/pages/sendout/Generic/components/HandoverSummary.css";

interface PropertyHandover {
  providerHandoverId: string;
  address: string;
  city: string;
  zipCode: string;
  region: string;
  date: string;
  dynamicForms: unknown[];
}

const HomeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 9.5L12 3L21 9.5V20C21 20.55 20.55 21 20 21H15V15H9V21H4C3.45 21 3 20.55 3 20V9.5Z"
      fill="#3b82f6"
      fillOpacity={0.8}
    />
  </svg>
);

const formatDate = (isoString: string): string =>
  new Date(isoString).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const toTitleCase = (str: string): string =>
  str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

interface RowProps {
  label: string;
  value: React.ReactNode;
}

const Row: React.FC<RowProps> = ({ label, value }) => (
  <tr>
    <td className="property-card__label">{label}</td>
    <td className="property-card__value">{value}</td>
  </tr>
);

interface Props {
  data: PropertyHandover;
}

export const HandoverSummary: React.FC<Props> = ({ data }) => {
  const city = toTitleCase(data.city);
  const { t } = useTranslation(SENDOUT_NAMESPACE);

  return (
    <div className="property-card">
      <div className="property-card__header">
        <div className="property-card__icon">
          <HomeIcon />
        </div>
        <div>
          <p className="property-card__title">{data.address}</p>
          <p className="property-card__subtitle">
            {data.zipCode} {city}, {data.region}
          </p>
        </div>
      </div>

      <div className="property-card__body">
        <table className="property-card__table">
          <tbody>
            <Row label={t("handoverAddress")} value={data.address} />
            <Row label={t("city")} value={city} />
            <Row label={t("postalCode")} value={data.zipCode} />
            <Row label={t("region")} value={data.region} />
            <Row label={t("handoverDate")} value={formatDate(data.date)} />
            <Row
              label={"ID"}
              value={<span className="property-card__value--mono">{data.providerHandoverId}</span>}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};